import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import WmsMobileLayout from "../../wmsMobileLayout";
import {FormattedMessage} from "react-intl";
import PageTitle from "../../../../components/WMS/Mobile/PageTitle";
import CreatePickingMissionForm from "../components/CreatePickingMissionForm";
import {Card, CardContent, Grid} from "@mui/material";
import CustomCheckbox from "../../../../components/checkbox/CustomCheckbox";
import {PickingMissionModelContext} from "../PickingMissionModelContext";

function CreatePickingMissionMobileContainer() {
    const {
        isModel,
        isModelAuto,
        setIsModelAuto,
        setIsModel
    } = useContext(PickingMissionModelContext)


    const handleIsModel = (checkValue) => {
        setIsModel(checkValue)
    }

    const handleIsModelAuto = (checkValue) => {
        setIsModelAuto(checkValue)
    }
    return (
        <WmsMobileLayout>
            <WmsMobileLayout.LeftHeader></WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader></WmsMobileLayout.RightHeader>
            <WmsMobileLayout.Content>
                <PageTitle
                    title={<FormattedMessage id={"wms.newPickingMission.title"}/>}
                    subtitle={<FormattedMessage id={"wms.newPickingMission.subtitle"}/>}
                />
                <Card>
                    <CardContent sx={{display: "flex", flexDirection:"column"}}>
                        <Grid container gap={"8px"} alignContent={"center"} sx={{marginTop: "24px", marginBottom: "32px"}}>
                            <CustomCheckbox checked={isModel} onChange={(event) => handleIsModel(event.target.checked)}/>
                            <span style={{fontSize: "14px", height: "fit-content", margin:"auto 0"}}>
                                <FormattedMessage id={"wms.newPickingMission.checkbox.label"}/>
                            </span>
                        </Grid>

                        {isModel && (
                            <Grid container gap={"8px"} alignContent={"center"} sx={{marginTop: "24px", marginBottom: "32px"}}>
                                <CustomCheckbox checked={isModelAuto} onChange={(event) => handleIsModelAuto(event.target.checked)}/>
                                <span style={{fontSize: "14px", height: "fit-content", margin:"auto 0"}}>
                                <FormattedMessage id={"wms.newPickingMission.isAuto.checkbox.label"}/>
                            </span>
                            </Grid>
                        )}

                        <CreatePickingMissionForm />
                    </CardContent>
                </Card>
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    );
}

export default CreatePickingMissionMobileContainer;